import gql from 'graphql-tag';

import { FRAGMENT_BRAND_VOICE } from 'src/graphql/brandVoices';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomer, BackendQueryCustomerArgs } from 'src/types/backend';

const QUERY = gql`
  query CustomerBrandVoices($id: ID!) {
    customer(id: $id) {
      id
      brandVoices {
        ...BrandVoice
      }
    }
  }
  ${FRAGMENT_BRAND_VOICE}
`;

type Variables = BackendQueryCustomerArgs;
type Result = Pick<BackendCustomer, 'id' | 'brandVoices'>;

export const queryCustomerBrandVoices = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
